import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';

import Axios from 'axios';
import _ from 'lodash';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';

import Config from '../config';

import Utils from '../Utils';
import { PrimeIcons } from 'primereact/api';

const Products = () => {
    const [rows, setRows] = useState([]);
    const [rowsCount, setRowsCount] = useState();
    const [loading, setLoading] = useState(true);
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 20,
        page: 1,
        sortField: 'id',
        sortOrder: -1,
        filters: {
            'sku': { value: null, matchMode: 'equals' },
            'title': { value: null, matchMode: 'equals' }
        }
    });

    useEffect(() => {
        loadLazyData();
    }, [lazyParams]);

    const loadLazyData = () => {
        setLoading(true);

        Axios.post(Config.API_BASE_URL+"/api/products", lazyParams)
            .then(result => result.data)
            .then(result => {
                setRows(result.data.rows);
                setRowsCount(result.data.count);
                setLoading(false);
            });
    };

    const onFilter = params => {
        setLazyParams(_.merge(params, { first: 0 }));
    }

    const detailButton = row => (
        <div className="actions">
            <Link to={`/products/${row.product_id}`}>
                <Button
                    icon={PrimeIcons.SEARCH}
                    className="p-button-rounded p-button-success"
                />
            </Link>
        </div>
    );

    const onSort = params => setLazyParams(params);
    const onPage = params => setLazyParams(params);

    return (
        <div className="grid">
            <div className="col-12">
                <div className="card">
                    <h5>Elenco dei prodotti presenti su Shopify</h5>
                    <DataTable
                      className="p-datatable-gridlines"
                      responsiveLayout="scroll"
                      lazy
                      dataKey="id"
                      value={rows}
                      paginator
                      showGridlines
                      first={lazyParams.first}
                      rows={lazyParams.rows}
                      totalRecords={rowsCount}
                      filters={lazyParams.filters}
                      filterDisplay="row"
                      onFilter={onFilter}
                      sortField={lazyParams.sortField}
                      sortOrder={lazyParams.sortOrder}
                      onSort={onSort}
                      onPage={onPage}
                      loading={loading}
                      emptyMessage="Nessun prodotto trovato."
                    >
                      <Column field="sku" header="AIC" filter showFilterMenu={false} style={{ maxWidth: '150px' }} />
                      <Column field="title" header="Titolo" filter showFilterMenu={false} />
                      <Column body={detailButton} />
                    </DataTable>
                </div>
            </div>
        </div>
    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(Products, comparisonFn);
